export default {"src":"/_next/static/media/NotSupportedImg.6f5007fe.svg","height":281,"width":301,"blurWidth":0,"blurHeight":0};